module.exports = __webpack_public_path__ + "img/Group 222.82d2f7f9.svg";